import { gql } from "@apollo/client";

export const CHANGE_STATE_PROVEEDOR_DISTRIBUIDOR = gql`
    mutation changeStateProveedorDistribuidor(        
            $idProveedorDistribuidor: Int!
            $state: Boolean!
         ){
        changeStateProveedorDistribuidor(
            idProveedorDistribuidor : $idProveedorDistribuidor,
            state : $state
        ) {
            idProveedorDistribuidor
        }
    }
`;